import { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";

//contexts
import { ItineraryContext } from "../../constants/layouts/itinerary-layout";
import { LocaleContext } from "../LangRouter";

const ItineraryRouteGuard = ({ children, redirect }) => {
    const location = useLocation(),
        { locale } = useContext(LocaleContext),
        { routes } = useContext(ItineraryContext);

    const routesBackup = JSON.parse(sessionStorage.getItem("visitedRoutes"));

    if (routes.includes(location.pathname) || location.pathname === `/${locale}/itinerary/favorites`) {
        return <>{children}</>;
    } else if (routesBackup && routesBackup.includes(location.pathname)) {
        return <>{children}</>;
    } else if (routesBackup && routesBackup.length) return <Navigate replace to={{ pathname: routesBackup[routesBackup.length - 1] }} />;
    else return <Navigate replace to={{ pathname: `/${locale}/itinerary/favorites` }} />;
};

export default ItineraryRouteGuard;
